import { format } from 'date-fns';

/*  Use these constants elsewhere to acheive 
    same date format across all MIKE applicaitons: 
*/
export const MIKE_DATE_FORMAT = 'dd MMM yyyy';
export const MIKE_DATETIME_FORMAT = 'dd MMM yyyy h:mm:ss a';
export const MIKE_TIME_FORMAT = 'h:mm:ss a';
const CUSTOMDATEFORMAT = "dd.MM.yyyy H:mm"
const CUSTOMSHORTATEFORMAT = "dd.MM.yyyy"
/*  Use this method to acheive 
    same date format across all MIKE applicaitons: 
*/
export function formatDate(
  inputDate: string | Date | number | null | undefined,
  showTime?: boolean
): string {
  if (!inputDate) {
    return '';
  }
  try {
    const d = new Date(inputDate);
    const form = showTime
      ? CUSTOMDATEFORMAT
      : CUSTOMSHORTATEFORMAT;
    const result = format(d, form);
    return result;
  } catch {
    return String(inputDate);
  }
}
